import { render, staticRenderFns } from "./SupportFAQItem.vue?vue&type=template&id=22a8e4df&scoped=true"
import script from "./SupportFAQItem.vue?vue&type=script&lang=js"
export * from "./SupportFAQItem.vue?vue&type=script&lang=js"
import style0 from "./SupportFAQItem.vue?vue&type=style&index=0&id=22a8e4df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8e4df",
  null
  
)

export default component.exports